<template>
  <div class="batch-generate-config">
    <div class="content">
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item>
          <router-link to="/">
            <a-icon type="home" />
            <span>首页</span>
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link :to="'/user-list/' + $route.params.platform">
            {{ bankName }}用户列表
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <router-link :to="'/transfer-record/' + $route.params.platform + '/' + $route.params.userId">
            转账记录
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>批量生成配置</a-breadcrumb-item>
      </a-breadcrumb>

      <div class="config-form">
        <a-form :form="form" layout="vertical">
          <a-card class="config-card">
            <bank-config v-model="configData" :user-id="$route.params.userId" :platform="$route.params.platform"
              @change="handleConfigChange"></bank-config>
          </a-card>

          <div class="form-actions">
            <a-space>
              <a-button @click="handleCancel">
                <a-icon type="rollback" />返回
              </a-button>
            </a-space>
          </div>

        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { platformMap } from '@/config/tableColumns'
import request from '@/utils/request'
import { API } from '@/config/api'
import BankConfig from '@/components/bank-configs/BankConfig.vue'
export default {
  name: 'BatchGenerateConfig',
  components: {
    BankConfig
  },
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      configData: {
        fixedItems: [],
        randomItems: []
      },
      userInfo: {}
    }
  },
  computed: {
    bankName() {
      return platformMap[this.$route.params.platform] || '未知平台'
    }
  },
  methods: {
    async fetchUserInfo() {
      try {
        const res = await request.post(API.USER_INFO, {
          platform: this.$route.params.platform,
          id: this.$route.params.userId
        })
        if (res.code === 1) {
          this.userInfo = res.data
        } else {
          this.$message.error(res.msg || '获取用户信息失败')
        }
      } catch (error) {
        this.$message.error(error.message || '获取用户信息失败')
      }
    },
    handleConfigChange() {
      console.log('配置已更新:', this.configData)
    },
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (!this.userInfo.card?.id) {
            this.$message.error('未获取到用户卡片信息')
            return
          }
          this.$confirm({
            title: '确认生成',
            content: '生成会删除之前生成的数据，是否继续？',
            okText: '确认',
            cancelText: '取消',
            onOk: async () => {
              this.loading = true
              try {
                const config = {
                  platform: this.$route.params.platform,
                  user_id: this.$route.params.userId,
                  card_id: this.userInfo.card.id,
                  start_time: values.startTime,
                  end_time: values.endTime,
                  start_balance: values.startBalance,
                  end_balance: values.endBalance,
                  generate_count: values.generateCount
                }
                const res = await request.post(API.BATCH_GENERATE, config)
                if (res.code === 1) {
                  this.$message.success('生成成功')
                  this.handleCancel()
                } else {
                  this.$message.error(res.msg || '生成失败')
                }
              } catch (error) {
                this.$message.error(error.message || '生成失败')
              } finally {
                this.loading = false
              }
            }
          })
        }
      })
    },
    handleCancel() {
      this.$router.push(`/transfer-record/${this.$route.params.platform}/${this.$route.params.userId}`)
    }
  },
  created() {
    this.fetchUserInfo()
  }
}
</script>

<style scoped>
.batch-generate-config {
  padding: 20px;
}

.content {
  background: #fff;
  padding: 24px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.breadcrumb {
  margin-bottom: 16px;
  text-align: left;
}

.config-card {
  margin-bottom: 24px;
}

.form-actions {
  margin-top: 24px;
  text-align: center;
}
</style>